/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Grid, Typography, Box, useTheme, useMediaQuery } from "@mui/material";
import Logo from "assets/images/cuverd-logo-header.png";
import flipIcon from "assets/images/flip_icon.png";
import andriodIcon from "assets/images/andriod.png";
import iosIcon from "assets/images/ios.png";
import { homeActions } from "actions";

const CuverdCouponCard = (props) => {
  const { genericDetails } = props;
  const theme = useTheme();
  const appData = JSON.parse(sessionStorage.getItem("applicationData"));
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const matchesMidWidth = useMediaQuery("(max-width:900px)");
  const [showFront, setShowFront] = useState(true);

  // useEffect(() => {
  //   return () => {
  //     updateGTMDataLayer({
  //       event: "View_Coupon_Discount",
  //       page: "Discount Coupon Card",
  //       screen: "Discount Coupon Card",
  //       screen_referrer: "Discount Coupon Card",
  //     });
  //   };
  // }, []);

  useEffect(() => {
    if (
      genericDetails &&
      genericDetails?.pharmacyDetailPrice &&
      genericDetails?.pharmacyDetailPrice.length &&
      genericDetails?.pharmacyDetailPrice[0]?.couponDisclaimerText
    ) {
      let child = document.getElementById("childFlipCard");
      let parent = document.getElementById("parentFlipCard");
      if (parent && child) {
        parent.style.height = `${child?.offsetHeight}px`;
      }
      // updateGTMDataLayer({
      //   event: "View_Coupon_Discount",
      //   page: "Discount Coupon Card",
      //   screen: "Discount Coupon Card",
      //   screen_title: "Discount Coupon Card",
      //   adjudication_id:
      //     genericDetails &&
      //     genericDetails?.pharmacyDetailPrice &&
      //     genericDetails?.memberId,
      //   coupon_url: genericDetails?.pharmacyDetailPrice[0]?.mailOrderUrl,
      //   coupon_provider: genericDetails?.id,
      // });
    }
  }, [genericDetails]);

  return (
    <Box
      className="flip-card"
      id="parentFlipCard"
      sx={{
        minHeight: showFront
          ? "300px"
          : matchesMinWidth
          ? "360px"
          : { xl: "300px", lg: "300px", md: "300px", sm: "300px" },
      }}
    >
      <Box
        className="flip-card-inner"
        sx={{ transform: showFront ? undefined : "rotateY(180deg)" }}
      >
        <div className="flip-card-front">
          <Grid container spacing={2} my={0} style={{ marginTop: "0px" }}>
            <Grid
              item
              sx={{
                // boxShadow: "0 0 1px 1px #d2d2d2",
                // borderRadius: 4,
                margin: "auto",
                position: "relative",
              }}
              px={2}
              pt={2}
              pb={1}
              sm={12}
              md={10}
              lg={12}
              id="childFlipCard"
            >
              <Box
                sx={{ position: "absolute", bottom: 0, right: 0 }}
                onClick={() => {
                  document
                    .querySelector("#sticky")
                    ?.setAttribute("class", "sticky-back");
                  setShowFront(false);
                }}
              >
                <img style={{ width: "40px" }} alt="flip-icon" src={flipIcon} />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  height: "35px",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    width: "40%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <Box sx={{ width: matchesMidWidth ? "60%" : "60%" }}>
                    <img style={{ width: "100%" }} alt="cuverd" src={Logo} />
                  </Box>
                  {genericDetails &&
                  genericDetails?.pharmacyDetailPrice &&
                  genericDetails?.pharmacyDetailPrice[0]?.poweredByFlag?.toLowerCase() ===
                    "y" &&
                  genericDetails?.pharmacyDetailPrice[0]?.poweredByText ? (
                    <Box>
                      <Typography
                        variant="h5LatoBold"
                        sx={{ fontSize: matchesMinWidth ? "8px" : "10px" }}
                      >
                        {genericDetails?.pharmacyDetailPrice[0]?.poweredByText}
                      </Typography>
                    </Box>
                  ) : null}
                </Box>
                <Box sx={{ width: "60%" }}>
                  <Typography
                    variant="h3LatoRegularNew"
                    sx={{
                      fontSize: matchesMinWidth ? "16px" : "22px",
                      fontWeight: "bold",
                    }}
                  >
                    Show this card to your pharmacist
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  borderRadius: "4px",
                  overflow: "hidden",
                  marginTop: matchesMinWidth ? "18px" : "16px",
                }}
              >
                <Box sx={{ display: "flex", height: 8 }}>
                  <Box
                    sx={{
                      backgroundColor: theme.palette.common.greenOne,
                      width: "25%",
                    }}
                  ></Box>
                  <Box
                    sx={{
                      backgroundColor: theme.palette.common.greenTwo,
                      width: "25%",
                    }}
                  ></Box>
                  <Box
                    sx={{
                      backgroundColor: theme.palette.common.greenThree,
                      width: "25%",
                    }}
                  ></Box>
                  <Box
                    sx={{
                      backgroundColor: theme.palette.common.greenFour,
                      width: "25%",
                    }}
                  ></Box>
                </Box>
                <Box
                  sx={{
                    height: 28,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    backgroundColor: theme.palette.primary.main,
                  }}
                >
                  <Typography>Prescription Savings Card*</Typography>
                </Box>
              </Box>
              <Grid
                item
                container
                py={1}
                sm={12}
                md={10}
                sx={{ margin: "auto" }}
                flexDirection="column"
              >
                <Box sx={{ margin: "auto", textAlign: "left" }}>
                  <Box mb={1} component="div">
                    <Typography
                      variant="h2LatoMedium"
                      sx={{
                        display: "inline-block",
                        width: 110,
                        textAlign: "left",
                      }}
                    >
                      BIN:
                    </Typography>
                    <Typography variant="h4LatoHeavy" sx={{ color: "#003d4c" }}>
                      &nbsp;
                      {genericDetails &&
                        genericDetails?.pharmacyDetailPrice &&
                        genericDetails?.pharmacyDetailPrice[0].bin}
                    </Typography>
                  </Box>
                  <Box mb={1} component="div">
                    <Typography
                      variant="h2LatoMedium"
                      sx={{
                        display: "inline-block",
                        width: 110,
                        textAlign: "left",
                      }}
                    >
                      PCN:
                    </Typography>
                    <Typography variant="h4LatoHeavy" sx={{ color: "#003d4c" }}>
                      &nbsp;
                      {genericDetails &&
                        genericDetails?.pharmacyDetailPrice &&
                        genericDetails?.pharmacyDetailPrice[0].pcn}
                    </Typography>
                  </Box>
                  <Box mb={1} component="div">
                    <Typography
                      variant="h2LatoMedium"
                      sx={{
                        display: "inline-block",
                        width: 110,
                        textAlign: "left",
                      }}
                    >
                      GROUP:
                    </Typography>
                    <Typography variant="h4LatoHeavy" sx={{ color: "#003d4c" }}>
                      &nbsp;
                      {genericDetails &&
                        genericDetails?.pharmacyDetailPrice &&
                        genericDetails?.pharmacyDetailPrice[0].groupNum}
                    </Typography>
                  </Box>
                  <Box my={1} component="div">
                    <Typography
                      variant="h2LatoMedium"
                      sx={{
                        display: "inline-block",
                        width: 110,
                        textAlign: "left",
                      }}
                    >
                      MEMBER ID:
                    </Typography>
                    <Typography variant="h4LatoHeavy" sx={{ color: "#003d4c" }}>
                      &nbsp;
                      {genericDetails &&
                        genericDetails?.pharmacyDetailPrice &&
                        genericDetails?.memberId}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    variant="h3LatoBold"
                    sx={{ fontSize: matchesMinWidth ? "15px" : undefined }}
                  >
                    * This is not insurance.
                  </Typography>
                </Box>
                <Box sx={{ textAlign: "center" }}>
                  <Typography variant="h4LatoRegular">
                    This is a FREE card and may not be sold.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </div>
        <div className="flip-card-back">
          <Grid
            sx={{ minHeight: "100%", height: "100%", marginTop: "0px" }}
            container
            spacing={2}
            my={0}
          >
            <Grid
              item
              sx={{
                minHeight: "100%",
                // boxShadow: "0 0 1px 1px #d2d2d2",
                // borderRadius: 4,
                margin: "auto",
                position: "relative",
                paddingTop: matchesMinWidth
                  ? "0px  !important"
                  : "8px !important",
              }}
              sm={12}
              md={10}
              lg={12}
            >
              <Box
                sx={{ position: "absolute", bottom: -4, right: 0 }}
                onClick={() => {
                  document
                    .querySelector("#sticky")
                    ?.setAttribute("class", "sticky-front");
                  setShowFront(true);
                }}
              >
                <img style={{ width: "40px" }} alt="flip-icon" src={flipIcon} />
              </Box>

              <Grid
                item
                container
                py={1}
                sm={12}
                md={12}
                sx={{
                  paddingTop: matches ? "4px  !important" : "8px !important",
                  paddingBottom: matches ? "4px  !important" : "8px !important",

                  margin: "auto",
                  //minHeight: "350px",
                  justifyContent: "center",
                }}
                flexDirection="column"
              >
                <Box sx={{ textAlign: "center" }}>
                  <Typography variant="h4LatoRegular" sx={{ fontSize: "18px" }}>
                    Get the app to keep on saving. It's free to both download
                    and use.
                  </Typography>
                </Box>

                <Box
                  sx={{
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    display: "flex",
                    paddingRight: matchesMinWidth ? "60px" : "0px",
                  }}
                >
                  <Box sx={{ textAlign: "center", paddingRight: "5%" }}>
                    <img
                      style={{ width: "100px", height: "100px" }}
                      src={appData?.app?.qrCodeUrl}
                      alt="QR Code"
                    />
                  </Box>
                  <Box
                    sx={{
                      textAlign: "center",
                      height: "100px",
                      paddingLeft: "5%",
                    }}
                  >
                    <div style={{ height: "50px" }}>
                      <a
                        rel="noreferrer"
                        target="_blank"
                        style={{ textDecoration: "none" }}
                        href={appData?.app?.googlePlayStoreUrl}
                      >
                        <img src={andriodIcon} alt="Andriod App" />
                      </a>
                    </div>
                    <div>
                      <a
                        rel="noreferrer"
                        target="_blank"
                        style={{ textDecoration: "none" }}
                        href={appData?.app?.appStoreUrl}
                      >
                        <img src={iosIcon} alt="IOS App" />
                      </a>
                    </div>
                  </Box>
                </Box>
                {genericDetails &&
                  genericDetails?.pharmacyDetailPrice &&
                  genericDetails?.pharmacyDetailPrice[0]
                    .pharmacySupportPhoneNumText && (
                    <Box sx={{ textAlign: "center" }}>
                      <Typography
                        variant="h3LatoBold"
                        sx={{ fontSize: matchesMinWidth ? "14px" : undefined }}
                      >
                        {
                          genericDetails?.pharmacyDetailPrice[0]
                            .pharmacySupportPhoneNumText
                        }
                      </Typography>
                    </Box>
                  )}
                {genericDetails &&
                  genericDetails?.pharmacyDetailPrice &&
                  genericDetails?.pharmacyDetailPrice[0]
                    .memberSupportPhoneNumText && (
                    <Box sx={{ textAlign: "center" }}>
                      <Typography
                        variant="h3LatoBold"
                        sx={{ fontSize: matchesMinWidth ? "14px" : undefined }}
                      >
                        {
                          genericDetails?.pharmacyDetailPrice[0]
                            .memberSupportPhoneNumText
                        }
                      </Typography>
                    </Box>
                  )}

                <Box
                  sx={{
                    textAlign: "center",
                    height: matches ? "100px" : "40px",
                    overflow: "hidden",
                    overflowY: "scroll",
                  }}
                >
                  <Typography
                    variant="h4LatoRegular"
                    sx={{ fontSize: matchesMinWidth ? "10px" : "12px" }}
                    dangerouslySetInnerHTML={{
                      __html:
                        genericDetails &&
                        genericDetails?.pharmacyDetailPrice &&
                        genericDetails?.pharmacyDetailPrice[0]
                          ?.couponDisclaimerText,
                    }}
                  ></Typography>
                </Box>
                <Box
                  sx={{
                    textAlign: "center",
                    paddingTop: matchesMinWidth ? "5%" : "2%",
                  }}
                >
                  <Typography
                    variant="h3LatoBold"
                    sx={{ fontSize: matchesMinWidth ? "15px" : undefined }}
                  >
                    * This is not insurance.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Box>
    </Box>
  );
};

const mapDispatchToProps = {
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
};

export default connect(null, mapDispatchToProps)(CuverdCouponCard);
